// ?> Social media links //

import {
	UilLinkedinAlt,
	UilGithub,
	UilTwitter,
	UilEnvelope,
} from "@iconscout/react-unicons";

const data = [
	{
		id: 1,
		username: "chamberezigbo@gmail.com",
		fontImage: <UilEnvelope />,
		url: "mailto:chamberezigbo@gmail.com",
	},
	{
		id: 2,
		username: "chamberezigbo/Twitter",
		fontImage: <UilTwitter />,
		url: "https://twitter.com/Chamberlin5050",
	},
	{
		id: 3,
		username: "chamberezigbo/Linkedin",
		fontImage: <UilLinkedinAlt />,
		url: "https://linkedin.com/in/chambertech",
	},
	{
		id: 4,
		username: "chamberezigbo/Github",
		fontImage: <UilGithub />,
		url: "https://github.com/chamberezigbo",
	},
];

export default data;
